module.exports = __webpack_public_path__ + "static/media/antigua-historic-24.cc03ccd8.jpg";